<template>
  <estimate
    v-if="!mobileVersion && quiz.showCalcDataInTheEnd"
    :answer="answer"
    :style="{left: estimate ? '0' : '-400px'}"
  />
  <button
    :class="style.closeButtonQuestionContact"
    v-if="
      mobileVersion && onlyFormBool && !startPage && !thankyouPage
        ? true
        : false
    "
    @click="closeContactModal"
  >
    <img src="$images/cross.svg" alt="" />
  </button>
  <section
    :class="getClassLeftPart()"
    id="leftPart"
    :style="{
      borderRadius: startPage
        ? '14px 14px 0 0'
        : onlyFormBool && mobileVersion
          ? '20px 20px 0 0'
          : 0,
      transform:
        !startPage && mobileVersion && onlyFormBool
          ? `translate(0, calc(${maxHeightDisplay - contactTranslate - 100 >= 0 ? maxHeightDisplay - contactTranslate - 100 + 'px' : '0px'}))`
          : '',
      backgroundColor:
        !startPage && mobileVersion && onlyFormBool && !thankyouPage
          ? 'transparent'
          : isLastQuestion && mobileVersion && !startPage && !thankyouPage
            ? '#1f172c'
            : '',
      left: quiz.showCalcDataInTheEnd && estimate ? '400px' : '0',
      top:
        (!startPage && mobileVersion && !onlyFormBool && !thankyouPage) ||
        (maxHeightDisplay - contactTranslate - 100 >= 0 && !startPage)
          ? '0px'
          : startPage || maxHeightDisplay - contactTranslate - 100 >= 0
            ? ''
            : '',
      height: leftPartHeight && mobileVersion ? leftPartHeight + 'px' : 'auto',
      paddingBottom: 'env(safe-area-inset-bottom) !important'
    }"
    ref="leftPart"
    @scroll="isCanScrollAnswerList = false"
  >
    <div
      v-if="!mobileVersion"
      :class="style.logo"
      :style="{
        height: !mobileVersion
          ? `${(quiz?.rangeSize / 100) * heightLogo}px`
          : ''
      }"
    >
      <img :style="getStyleLogo()" :src="getLogoQuiz" alt="" ref="logo" />
    </div>
    <section
      v-if="!startPage && !thankyouPage && !onlyFormBool"
      :class="style.processBar"
      id="processBar"
      :style="
        isLastQuestion && mobileVersion
          ? {transition: '2s', opacity: '0', display: 'none'}
          : {}
      "
    >
      <div :class="style.textBar" :style="{display: 'none'}">
        <span v-text="'Готово: ' + getProcessQuestions() + '%'" />
      </div>
      <div :class="style.process">
        <span :style="{width: getProcessQuestions() + '%'}" />
        <span :style="{width: 100 - getProcessQuestions() + '%'}" />
      </div>
    </section>
    <ActionComponent v-if="estimate && !mobileVersion" />
    <div :class="style.mainBlockLeftPart" id="animation" v-show="startPage">
      <ActionComponent
        v-if="!mobileVersion"
        :style="{
          marginLeft: !mobileVersion ? '30px' : '10px',
          order: mobileVersion ? 3 : 0
        }"
      />
      <h2
        :style="{
          marginTop:
            modifyQuiz('get', '', ['actionList'])?.length > 0 ? '20px' : '',
          width: mobileVersion ? '95%!important' : ''
        }"
        v-html="insertNonBreakingSpaces(modifyQuiz('get', '', ['header']))"
      />
      <p
        style="width: 80%"
        v-html="insertNonBreakingSpaces(modifyQuiz('get', '', ['paragraf']))"
        :class="style.description"
      />
      <FormComponent
        v-if="onlyFormBoolInPage"
        :answerInput="answerInput"
        :answer="answer"
        :style="{padding: !mobileVersion ? '16px 30px' : '0'}"
      />
      <ButtonComponent
        v-if="mobileVersion"
        :text="nextButton ? nextButton : 'Рассчитать'"
        :styleButton="{order: '-1'}"
        :isLongButton="true"
        :isPurple="true"
        @click="startCalculation($event)"
      />
      <ButtonComponent
        v-else
        :isErrorSendForm="isErrorSendForm"
        :isSuccessAndNotSend="isSuccessAndNotSend"
        :isFormSend="isFormSend"
        :text="nextButton ? nextButton : 'Рассчитать'"
        :ifText="isSuccessAndNotSend"
        @click="startCalculation"
      />
    </div>
    <section
      :class="style.questionList"
      v-show="n == questionsListCont && !thankyouPage && !startPage"
      v-for="(questionList, n) in questions"
      :style="{
        backgroundColor: mobileVersion && onlyFormBool ? 'transparent' : ''
      }"
      :key="n"
    >
      <div
        :class="style.questionMainBlock"
        id="question"
        v-for="(question, num) in questionList"
        :key="num"
        :style="{
          marginBottom: isLastQuestion && mobileVersion ? '0' : ''
        }"
      >
        <div :class="style.question">
          <h2
            :style="{
              marginBottom: question.type == 'checkbox-dental' ? '10px' : '',
              display:
                mobileVersion && question.type == 'contacts' ? 'none' : 'block'
            }"
            v-html="
              question.type != 'contacts'
                ? insertNonBreakingSpaces(getQuestion(question))
                : insertNonBreakingSpaces(question.contacts?.header as string)
            "
          />
          <p
            v-if="question?.contacts?.paragraph"
            v-html="insertNonBreakingSpaces(question?.contacts?.paragraph)"
            :style="{
              display:
                mobileVersion && (question.type as 'contacts') == 'contacts'
                  ? 'none'
                  : 'block'
            }"
          />
        </div>
        <div
          :class="[
            style.answerList,
            onlyFormBool && mobileVersion ? style.hiddenScrollBar : '',
            question.type == 'contacts' && mobileVersion
              ? style.contactAnimation
              : ''
          ]"
          :style="
            question.type == 'contacts' && mobileVersion
              ? {
                  height: `${contactTranslate && onlyFormBool && getAnswerListHeight > 580 ? contactTranslate + 'px' : mobileVersion && onlyFormBool ? 'auto!important' : '100dvh!important'}`,
                  position: 'relative',
                  left: '-10px',
                  width: '100vw',
                  justifyContent: 'space-between'
                }
              : {
                  height: 'auto!important',
                  paddingBottom: mobileVersion
                    ? currentAnswerPadding + 'px'
                    : ''
                }
          "
          ref="answerList"
        >
          <CheckBoxRadioButton
            v-show="variant?.text ?? ''"
            :style="{width: getWidthAnswer(n)}"
            v-if="
              ['radio', 'checkbox'].includes(question?.type?.split('-')[0]) &&
              question?.type != 'checkbox-dental'
            "
            v-for="(variant, index) in question.variants"
            :key="question.question + '-' + index"
            :question="question"
            :variant="variant"
            :answerInput="answerInput"
          />
          <div
            :style="{width: '100%'}"
            :class="style.answer"
            v-else-if="question.type == 'select'"
          >
            <span
              v-if="!answer[question.question] && question.placeholder"
              :class="style.placeholder"
              v-text="question.placeholder"
            />
            <select
              v-model="answer[question.question]"
              name=""
              id=""
              :question="answer[question.question]"
            >
              <option
                v-for="variant in question.variants"
                v-show="variant?.text"
                :value="variant?.text"
                v-text="variant?.text"
              />
            </select>
          </div>
          <FormComponent
            :answerInput="answerInput"
            :answer="answer"
            v-else-if="question.type == 'contacts' && !mobileVersion"
          />
          <ContactQuestion
            :answerInput="answerInput"
            :answer="answer"
            :isFormSend="isFormSend"
            :isErrorSendForm="isErrorSendForm"
            :isLastQuestionAndNotError="isLastQuestionAndNotError"
            :isLastQuestion="isLastQuestion"
            :isSuccessAndNotSend="isSuccessAndNotSend"
            :handleClick="handleClick"
            v-else-if="question.type == 'contacts' && mobileVersion"
          />

          <div v-else-if="question.type == 'checkbox-dental'">
            <div :class="style.pleaceSelectDental">
              <img src="$images/selectDental.svg" alt="" />
              <p>
                Выберите зубы которые планируете заменить, если затрудняетесь
                ответить, пропустите вопрос
              </p>
            </div>
            <div :class="style.answer" :style="{width: '100% !important'}">
              <div :class="style.bothJaws">
                <div :class="style.selectJaw">
                  <div :class="style.maxilla">
                    <img
                      @mouseover="hoverToothList['maxilla'] = index"
                      @mouseleave="hoverToothList['maxilla'] = null"
                      @click="chooseTooth(index, 'maxilla')"
                      :style="{top: obj.top, left: obj.left}"
                      v-for="(obj, index) in maxilla"
                      :src="getDentalImg(index, 'maxilla')"
                      :class="getClassDental(index, 'maxilla')"
                    />
                  </div>

                  <div
                    :class="style.answer"
                    :style="{width: '100% !important'}"
                  >
                    <input
                      name="dental"
                      @change="answerInput($event)"
                      :id="dentalVariants[0]"
                      type="checkbox"
                    />
                    <label :class="style.answerImg" :for="dentalVariants[0]">
                      <div :class="style.content">
                        <span :class="style.fakeBefore" />
                        <span
                          v-text="dentalVariants[0]"
                          :class="style.textContent"
                        ></span>
                      </div>
                    </label>
                  </div>
                </div>
                <div :class="style.selectJaw">
                  <div :class="style.mandible">
                    <img
                      @mouseover="hoverToothList['mandible'] = index"
                      @mouseleave="hoverToothList['mandible'] = null"
                      @click="chooseTooth(index, 'mandible')"
                      :style="{top: obj.top, left: obj.left}"
                      v-for="(obj, index) in mandible"
                      :src="getDentalImg(index, 'mandible')"
                      :class="getClassDental(index, 'mandible')"
                    />
                  </div>

                  <div
                    :class="style.answer"
                    :style="{width: '100% !important'}"
                  >
                    <input
                      name="dental"
                      @change="answerInput($event)"
                      :id="dentalVariants[1]"
                      type="checkbox"
                    />
                    <label :class="style.answerImg" :for="dentalVariants[1]">
                      <div :class="style.content">
                        <span :class="style.fakeBefore" />
                        <span
                          v-text="dentalVariants[1]"
                          :class="style.textContent"
                        ></span>
                      </div>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div :style="{width: '100% !important'}" :class="style.answer">
                <input
                  name="dental"
                  @change="answerInput($event)"
                  :id="dentalVariants[2]"
                  type="checkbox"
                />
                <label :class="style.answerImg" :for="dentalVariants[2]">
                  <div :class="style.content">
                    <span
                      :style="{borderRadius: '50% !important'}"
                      :class="style.fakeBefore"
                    />
                    <span
                      v-text="dentalVariants[2]"
                      :class="style.textContent"
                    ></span>
                  </div>
                </label>
              </div>
            </div>
          </div>
          <div
            :class="style.information"
            v-else-if="question.type == 'information'"
          >
            <video
              v-if="isVideoPath(question.information)"
              :src="getMediaUrl(question.information)"
              autoplay
              muted
              loop
              playsinline
              webkit-playsinline
              preload="auto"
            />

            <div v-else id="pictureHere" :data-img="question.information" />
          </div>
          <div :style="{width: '100%'}" :class="style.answer" v-else>
            <input
              :placeholder="question.placeholder"
              v-model="answer[question.question]"
              :type="question.type"
              v-if="question.type == 'text' || question.type == 'email'"
            />
            <textarea
              :placeholder="question.placeholder"
              v-model="answer[question.question]"
              v-else
              name=""
              id=""
            />
          </div>

          <AnimationArrowComponent
            :isCanScrollAnswerList="isCanScrollAnswerList"
            v-if="
              ['radio', 'checkbox'].includes(question?.type?.split('-')[0]) &&
              question?.type != 'checkbox-dental' &&
              mobileVersion
            "
          />
        </div>
      </div>

      <div
        ref="buttons"
        :class="style.buttons"
        :style="{
          position:
            questionsListCont === questions.length - 1
              ? 'relative'
              : mobileVersion
                ? 'fixed'
                : 'sticky',
          display:
            mobileVersion && (isLastQuestion || isCurrentContactQuestion)
              ? 'none'
              : 'flex'
        }"
      >
        <button
          @click.prevent="handleClick(null, 'back')"
          :class="style.backButton"
          v-if="!mobileVersion"
        >
          <img src="$images/arrowBlack2.svg" alt="" />
        </button>
        <ButtonComponent
          :styleButton="
            isFormSend ? {backgroundColor: '#9F63FC!important'} : {}
          "
          :isErrorSendForm="isErrorSendForm"
          :isLastQuestionAndNotError="isLastQuestionAndNotError"
          :isLastQuestion="isLastQuestion"
          :isSuccessAndNotSend="isSuccessAndNotSend"
          :isFormSend="isFormSend"
          :withoutMargin="true"
          :fakeAfter="false"
          :isGreeting="false"
          :ifText="!isLastQuestion"
          :elseIfText="isSuccessAndNotSend"
          :alternativeText="textContactButton ?? nextButton"
          :text="'Далее'"
          @click.prevent="handleClick($event, 'next')"
        />
        <span
          :class="style.underButtonText"
          v-if="mobileVersion && quiz?.textBellowButtonMobile"
          v-text="quiz.textBellowButtonMobile"
        />
      </div>
    </section>
    <section :class="style.thankYouPage" v-if="thankyouPage">
      <h2 v-html="insertNonBreakingSpaces(thankyouPageObj.question)" />
      <p
        v-html="
          insertNonBreakingSpaces(
            thankyouPageObj?.contacts?.paragraph as string
          )
        "
      />
      <video
        v-if="
          thankyouPageObj.thankYouImg &&
          isVideoPath(thankyouPageObj.thankYouImg)
        "
        :src="getMediaUrl(thankyouPageObj.thankYouImg)"
        autoplay
        muted
        loop
        playsinline
        webkit-playsinline
        preload="auto"
      />

      <div
        v-else-if="thankyouPageObj.thankYouImg"
        id="pictureHere"
        :data-img="thankyouPageObj.thankYouImg"
      />
    </section>

    <section v-if="!mobileVersion" :class="style.footer">
      <section
        v-for="(address, index) in visibleAddresses"
        :key="`address-${index}`"
      >
        <div :class="style.icon"><img src="$images/address.svg" alt="" /></div>
        <p>{{ address ? address : "" }}</p>
      </section>
      <section v-for="(phone, index) in visiblePhones" :key="`phone-${index}`">
        <div :class="style.icon"><img src="$images/phone.svg" alt="" /></div>
        <p>{{ phone ? phone : "" }}</p>
      </section>
      <section :class="style.social" v-if="quiz.сompanyName">
        <p>
          <span v-if="quiz.сompanyName" v-text="quiz.сompanyName" />
        </p>
        <p v-show="false">
          Нажимая на кнопку вы даёте согласия на обработку персональных данных и
          соглашаетесь с
          <a href="#">политикой конфиденциальности</a>
        </p>
      </section>
      <section v-show="false" style="margin: 0" :class="style.social">
        <p style="margin: 0">
          Сделано в <a href="https://readds.ru">Readds</a>
        </p>
      </section>
    </section>
  </section>
  <CallComponent
    ref="callComponent"
    :phone="answer['Телефон']"
    :widget-id="quiz.envyboxWidgetId || ''"
  />
</template>

<script lang="ts">
import {encryptQuizSendPayload} from "@/scripts/quizSendEncryption";
import estimate from "../../estimate/estimateComponent.vue";
import LoaderTextButton from "@/elements/loaderTextButton/LoaderTextButton.vue";
import PhoneInput from "@/elements/phoneInput/PhoneInput.vue";
import CallComponent from "../../CallComponents.vue";
import {insertNonBreakingSpaces} from "@/scripts/typographer";
import style from "./LeftPart.module.scss";
import maxilla from "$images/maxilla/dental";
import mandible from "$images/mandible/dental";
import device from "current-device";
import {addMetrik, getYMCID} from "@/scripts/metrik";
import {BASEURL, postKeepalive} from "@/http";
import ActionComponent from "../components/ActionComponent/ActionComponent.vue";
import FormComponent from "../components/FormComponent/FormComponent.vue";
import CheckBoxRadioButton from "@/elements/quizElements/checkboxRadioButton/CheckBoxRadioButton.vue";
import ButtonComponent from "@/elements/buttonPurpleWhite/ButtonComponent.vue";
import ContactQuestion from "../components/Questions/ContactQuestion/ContactQuestion.vue";
import {defineComponent} from "vue";
import {modifyQuiz} from "@/page/quiz/scriptQuiz";
import type {metricIntegration} from "@/page/setting/integration/IntegrationTypes";
import AnimationArrowComponent from "@/elements/quizElements/arrowAnimationComponent/arrowAnimationComponent.vue";
import {
  answer,
  chooseToothList,
  dataAnalyticsSend,
  hoverToothList,
  questions,
  Quiz
} from "@/page/quiz/typeQuiz";
import {API} from "@/api/generated.js";

type ContactsDisplayType = "onlyAddress" | "onlyPhone" | "both";

const createAnalyticsSessionId = (): string => {
  if (typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }

  const randomPart = crypto.getRandomValues(new Uint32Array(2)).join("");
  return `${Date.now()}-${randomPart}`;
};

export default defineComponent({
  name: "LeftQuizPart",
  components: {
    AnimationArrowComponent,
    ContactQuestion,
    ButtonComponent,
    CheckBoxRadioButton,
    FormComponent,
    ActionComponent,
    LoaderTextButton,
    estimate,
    PhoneInput,
    CallComponent
  },
  props: {
    metricIds: {
      type: Array<{id: string}>,
      default: []
    },
    sectionRightPart: {
      type: Array<HTMLElement>,
      default: [] as Array<HTMLElement>
    },
    leftPartHeight: Number
  },
  data() {
    return {
      insertNonBreakingSpaces,
      maxilla,
      mandible,
      style,
      answerError: new Set(),
      questionsListCont: 0,
      estimate: false,
      chooseToothList: {
        maxilla: [],
        mandible: []
      } as chooseToothList,
      questions: [] as questions[][],
      DOMAIN: "readds.ru",
      isFormSend: false,
      thankyouPage: false,
      isErrorSendForm: false,
      hoverToothList: {
        maxilla: null,
        mandible: null
      } as hoverToothList,
      thankyouPageObj: {} as questions,
      dentalVariants: [
        "Вся верхняя челюсть",
        "Вся нижняя челюсть",
        "Затрудняюсь ответить, нужна консультация"
      ],
      contactTranslate: 0,
      maxHeightDisplay: window.innerHeight + 100,
      analyticsQuestions: {} as dataAnalyticsSend,
      analyticsSessionId: createAnalyticsSessionId(),
      srcUploaded: [] as string[],
      clickTimeout: null as ReturnType<typeof setTimeout> | null,
      heightLogo: 0,
      answer: {
        connection: "Телефон"
      } as answer,
      answerHeights: [] as number[],
      currentAnswerPadding: 0,
      isCanScrollAnswerList: false,
      modifyQuiz
    };
  },
  emits: ["sendSectionLeftPart"],
  mounted() {
    if (this.quiz.faviconQuiz) {
      this.setFavicon(this.quiz.faviconQuiz);
    }
    setTimeout(() => {
      this.answerHeights = new Array(this.quiz.questions.length).fill(0);
      this.getLogoHeight();

      document.addEventListener("keydown", this.keyboard);
      this.setAnaliticsQuestions();
      this.sendSectionLeftPart();
      this.thankyouPageObj = this.quiz.questions.filter((q) => {
        return q.type == "ThankYouPages";
      })[0];
      this.setQuestions();
    }, 300);

    // update leftPartHeight for Safari
  },
  beforeUnmount() {
    document.removeEventListener("keydown", this.keyboard);
    window.removeEventListener("scroll", this.isCanScrollAnswerListHandler);
  },
  methods: {
    setFavicon(url: string): void {
      let link =
        (document.querySelector("link[rel*='icon']") as HTMLLinkElement) ||
        document.createElement("link");

      link.type = "image/svg+xml";
      link.rel = "icon";
      const href = this.getImg(url).replace("url(", "").replace(")", "");
      link.href = href + (href.includes("?") ? "&" : "?") + `v=${Date.now()}`;
      document.getElementsByTagName("head")[0].appendChild(link);
    },
    sendAnalytics(type: string | null) {
      if (this.onlyFormBool) {
        return;
      }
      let obj = {
        quizId: this.quiz._id,
        sessionId: this.analyticsSessionId,
        ABTest: this.quiz.ABTestBool && this.quiz.nowReturn != "quiz",
        mobile: this.mobileVersion,
        type,
        data: this.analyticsQuestions
      };
      const analyticsUrl = BASEURL + "/quiz/analytics";
      const payload = JSON.stringify(obj);
      void postKeepalive("quiz/analytics", obj).catch(() => {
        const blob = new Blob([payload], {type: "application/json"});
        navigator.sendBeacon(analyticsUrl, blob);
      });
      this.analyticsQuestions = {};
    },
    setAnaliticsQuestions() {
      if (!this.questions) {
        this.setQuestions();
      }

      let questions = "";
      let type: string | null = null;
      if (this.thankyouPage) {
        questions = this.thankyouPageObj.question;
        type = this.thankyouPageObj.type || "ThankYouPages";
      } else if (this.startPage) {
        questions = "Стартовая страница";
      } else if (!this.startPage && this.questionsListCont == 0) {
        questions = this.questions[0][0].question;
      } else {
        questions = this.questions[this.questionsListCont][0].question;
      }

      let date = new Date().toISOString().split("T")[0];
      if (!this.analyticsQuestions[date]) {
        this.analyticsQuestions[date] = [];
      }
      if (!this.analyticsQuestions[date].includes(questions)) {
        this.analyticsQuestions[date].push(questions);
      }
      this.sendAnalytics(type);
    },
    closeContactModal() {
      if (this.mobileVersion) {
        let preLeftPart = this.$refs.leftPart;
        let leftPart: HTMLElement;
        if (!preLeftPart) {
          return;
        }
        if (Array.isArray(preLeftPart)) {
          leftPart = preLeftPart[0];
        } else {
          leftPart = preLeftPart;
        }
        leftPart.style.transform = "translate(0, 100%)";
        leftPart.style.transition = ".5s";
        setTimeout(() => {
          leftPart.style.transition = "auto";
          this.backStep();
        }, 400);
      }
    },
    getImg(path: string) {
      if (path?.includes("logo.")) {
        return this.getLogoQuiz;
      }

      if (path?.includes("blob:")) {
        return `url(${path})`;
      }
      let dateTime = new Date().getTime();
      if (this.isVideoPath(path) || path?.includes("logo")) {
        return `https://${this.DOMAIN}/api/img?name=${encodeURIComponent(path)}&v=${dateTime}`;
      }
      if (path) {
        return `url(https://${this.DOMAIN}/api/img?name=${encodeURIComponent(path)})`;
      }
      return `url('https://${this.DOMAIN}/api/img?name=logoWidget.svg')`;
    },
    getMediaUrl(path = ""): string {
      if (!path) {
        return `https://${this.DOMAIN}/api/img?name=logoWidget.svg`;
      }

      if (path.startsWith("blob:") || path.startsWith("data:")) {
        return path;
      }

      if (path.startsWith("http://") || path.startsWith("https://")) {
        return path;
      }

      return `https://${this.DOMAIN}/api/img?name=${encodeURIComponent(path)}`;
    },
    isVideoPath(path = ""): boolean {
      return /\.(mp4|webm|ogg)(?:$|[?#])/i.test(path);
    },
    sendSectionLeftPart() {
      this.$emit("sendSectionLeftPart", this.$refs.leftPart);
    },
    setQuestions() {
      let count = 0;
      if (this.onlyFormBool && this.mobileVersion) {
        if (this.questions[count] == undefined) {
          this.questions[count] = [];
        }
        let question = this.quiz?.questions.find((item) => {
          return item && item?.type == "contacts";
        });
        if (question) {
          this.questions[count].push(question);
        }
        return;
      }
      let arr = this.quiz?.questions.filter((q) => {
        return q && q?.type != "ThankYouPages";
      });

      arr.forEach((question) => {
        if (this.questions[count] == undefined) {
          this.questions[count] = [];
        }
        this.questions[count].push(question);
        count++;
      });
    },
    autoFocusFirstInput() {
      setTimeout(() => {
        let questionListBlokNotFiltered = document.querySelectorAll(
          "." + this.style.questionList
        ) as NodeListOf<HTMLElement>;
        let questionListBlok = Array.from(questionListBlokNotFiltered).filter(
          (item) => {
            return item.style.display != "none";
          }
        )[0];
        if (!questionListBlok) {
          return;
        }
        let firstInput = questionListBlok.querySelector("input");
        if (firstInput?.type != "radio" && firstInput?.type != "checkbox") {
          firstInput?.focus();
        }
        window.scrollTo({top: -100, behavior: "smooth"});
      }, 10);
    },
    inputError(input: HTMLInputElement | HTMLLabelElement) {
      if (input?.style == null) {
        return;
      }
      input.style.border = "2px solid #ffd3d3";
      setTimeout(() => {
        input.style.transition = "border 2s";
        input.style.border = "2px solid transparent";
        setTimeout(() => {
          input.style.transition = "border 0s";
          this.$nextTick(() => {
            input.style = "";
          });
        }, 1500);
      }, 10);
    },
    isTelegramConnection() {
      return ["Телеграм", "Telegram"].includes(this.answer?.connection);
    },
    isPhoneMaskDisabled() {
      const contactsQuestion = this.quiz.questions?.find((question) => {
        return question.type === "contacts";
      });

      return Boolean(contactsQuestion?.phoneMask);
    },
    getCurrentContactsPhoneInput() {
      const visibleQuestion = Array.from(
        document.querySelectorAll("." + this.style.questionList)
      ).find((question) => {
        return (
          question instanceof HTMLElement &&
          question.getClientRects().length > 0
        );
      }) as HTMLElement | undefined;

      return (visibleQuestion ?? document).querySelector(
        '[name="contacts-phone"]'
      ) as HTMLInputElement | null;
    },
    isContactsPhoneComplete(input: HTMLInputElement | null) {
      if (!input) {
        return false;
      }

      if (input.name !== "contacts-phone") {
        return true;
      }

      const phoneDigits = input.value.replaceAll(/\D/g, "");

      if (this.isPhoneMaskDisabled()) {
        return input.value.trim() !== "";
      }

      if (input.id === "phone-masked") {
        return phoneDigits.length >= 10;
      }

      return phoneDigits !== "";
    },
    syncContactPhone(input: HTMLInputElement | null) {
      if (input && input.name === "contacts-phone") {
        this.setContacts(input);
      }
    },
    chooseTooth(i: number, name: string) {
      const index = this.chooseToothList[name].indexOf(i);
      if (index == -1) {
        this.chooseToothList[name].push(i);
      } else {
        this.chooseToothList[name].splice(index, 1);
      }
    },
    keyboard(e: KeyboardEvent) {
      if (e.code == "Enter") {
        if (this.startPage) {
          this.startCalculation();
        } else if (!this.thankyouPage) {
          this.nextOrCalculation();
        }
      }
    },
    selectionEntireJaw(bool: boolean, name: string) {
      this.chooseToothList[name] = [];
      if (bool) {
        for (let index = 0; index < 16; index++) {
          this.chooseToothList[name].push(index);
        }
      }
    },
    backStep() {
      if (this.questionsListCont == 0) {
        document.body.style.overflowY = "auto";
        if (this.sectionRightPart?.length) {
          this.sectionRightPart.forEach((HTMLElement) => {
            HTMLElement.style.display = "block";
          });
        }

        let last = document.querySelector(
          "." + this.style.questionList
        ) as HTMLElement;
        let current = document.querySelector(
          "." + this.style.leftPart + " div#animation"
        ) as HTMLElement;
        this.animationSwitchingPage(
          last,
          current,
          () => {
            this.$quizStore.setStartPage(true);
          },
          "back"
        );
      } else {
        let questionList = Array.from(
          document.querySelectorAll("." + this.style.questionList)
        );
        let last = questionList[this.questionsListCont] as HTMLElement;
        let current = questionList[this.questionsListCont - 1] as HTMLElement;
        if (this.questionsListCont == this.quiz.questions.length - 1) {
          this.questionsListCont--;
        } else {
          this.animationSwitchingPage(
            last,
            current,
            () => {
              this.questionsListCont--;
            },
            "back"
          );
        }
      }
    },
    handleSingleClick(movement: string) {
      if (movement == "next") {
        this.nextOrCalculation();
      } else {
        this.backStep();
      }
    },
    checkingForErrors() {
      this.answerError.clear();
      let errProof = true;

      if (this.questions[this.questionsListCont][0].skip) {
        return true;
      }

      let inputs = Array.from(document.querySelectorAll("input"));
      let select = Array.from(document.querySelectorAll("select"));
      let textarea = Array.from(document.querySelectorAll("textarea"));

      let all = [...inputs, ...select, ...textarea].filter((i) => {
        let element = i?.closest(`.${this.style.questionList}`) as HTMLElement;
        return element ? element.getClientRects().length > 0 : false;
      });

      all.forEach((input) => {
        if (
          !this.isTelegramConnection() &&
          input.name == "contacts-phone" &&
          !this.isContactsPhoneComplete(input as HTMLInputElement) &&
          input instanceof HTMLInputElement
        ) {
          this.inputError(input);
          errProof = false;
        } else if (
          input.value == "" &&
          !["contacts-name", "contacts-email"].includes(input?.name) &&
          !(input.type === "radio" || input.type === "checkbox")
        ) {
          if (input instanceof HTMLInputElement) {
            this.inputError(input);
          }
          errProof = false;
        }
      });

      let grouped = new Map<string, HTMLInputElement[]>();
      all.forEach((input) => {
        if (
          (input.type === "radio" || input.type === "checkbox") &&
          input.name &&
          input.name !== "dental"
        ) {
          if (!grouped.has(input.name)) {
            grouped.set(input.name, []);
          }
          grouped.get(input.name)!.push(input as HTMLInputElement);
        }
      });

      grouped.forEach((group) => {
        if (!group.some((i) => i.checked)) {
          group.forEach((input) => {
            let label = input.nextElementSibling;
            if (label instanceof HTMLLabelElement) {
              this.inputError(label);
            }
            errProof = false;
          });
        }
      });

      let dentalInputs = all.filter(
        (i) =>
          (i.type === "radio" || i.type === "checkbox") && i.name === "dental"
      ) as HTMLInputElement[];

      if (dentalInputs.length > 0) {
        const {maxilla, mandible} = this.chooseToothList;
        let checkedDental = maxilla.length == 0 && mandible.length == 0;
        let checkedArr = dentalInputs.map((i) => i.checked);

        if (checkedDental && !checkedArr.includes(true)) {
          let label = dentalInputs[0]
            .closest("." + this.style.answer)
            ?.querySelector("label");
          if (label instanceof HTMLLabelElement) {
            this.inputError(label);
          }
          errProof = false;
        }
      }

      return errProof;
    },

    animationSwitchingPage(
      last: HTMLElement,
      current: HTMLElement,
      func: Function,
      move: string = "next"
    ) {
      if (
        move == "back" &&
        current.classList.contains(this.style.mainBlockLeftPart)
      ) {
        func();
        return;
      }

      if (
        !last.classList.contains(this.style.mainBlockLeftPart) &&
        !(this.onlyFormBool && this.mobileVersion)
      ) {
        current.style = "";
        const questionMainBlockLast = last.querySelector(
          `.${this.style.questionMainBlock}`
        ) as HTMLElement;
        const questionMainBlockCurrent = current.querySelector(
          `.${this.style.questionMainBlock}`
        ) as HTMLElement;
        const buttonsCurrent = current.querySelector(
          `.${this.style.buttons}`
        ) as HTMLElement;
        if (!this.mobileVersion && buttonsCurrent !== null) {
          buttonsCurrent.style.display = "none";
        }

        if (move == "next" && questionMainBlockCurrent) {
          questionMainBlockCurrent.style.transform = "";
          questionMainBlockCurrent.style.top = "0";
          let div = current.querySelector("div");
          if (div && div.nextElementSibling) {
            let nextElement = div.nextElementSibling as HTMLElement;
            nextElement.style.display = "none";
          }
        }

        questionMainBlockLast.style.transform = `translateX(-110%)`;
        questionMainBlockLast.style.opacity = "0";
        let answerList = questionMainBlockLast.querySelector(
          `.${this.style.answerList}`
        ) as HTMLElement;
        if (!answerList) {
          return;
        }
        answerList.style.overflow = "hidden";

        if (move == "back") {
          current.style.display = "none";
          questionMainBlockLast.style.transform = "translateX(110%)";
          questionMainBlockLast.style.opacity = "1";
          questionMainBlockCurrent.style.transform = "translateX(0%)";
        }

        [questionMainBlockLast, questionMainBlockCurrent].forEach((element) => {
          element.style.transition = ".7s ease-out";
          if (!this.mobileVersion) {
            element.style.transition = ".4s ease-out";
          }
        });
        questionMainBlockCurrent.style.opacity = "0";
        // questionMainBlockCurrent.style.transform = "translateX(50%)";

        setTimeout(() => {
          current.style.display = "none";
        }, 500);

        if (this.mobileVersion) {
          setTimeout(() => {
            if (!(this.questionsListCont === this.questions.length - 2)) {
              this.answerListAnimation(
                questionMainBlockCurrent as HTMLDivElement
              );
            }
            setTimeout(() => {
              questionMainBlockCurrent.style.opacity = "1";
            }, 300);
            if (move == "back") {
              questionMainBlockLast.style.opacity = "1";
            }
          }, 500);
        } else {
          setTimeout(() => {
            questionMainBlockCurrent.style.opacity = "1";
            if (move == "back") {
              questionMainBlockLast.style.opacity = "1";
            }
          }, 600);
        }
        setTimeout(() => {
          func();
          this.setAnaliticsQuestions();
          if (move == "next") {
            current.style.display = "";
          }
          if (!this.mobileVersion) {
            buttonsCurrent.style.display = "block";
          }
        }, 600);
      } else {
        func();
        this.setAnaliticsQuestions();
      }
    },
    answerListAnimation(questionMainBlock: HTMLDivElement) {
      const question = questionMainBlock.querySelector(
        "." + this.style.question
      ) as HTMLDivElement;
      const answerList = questionMainBlock.querySelector(
        "." + this.style.answerList
      ) as HTMLDivElement;

      const h2 = question?.querySelector("h2") as HTMLHeadingElement;
      const p = question?.querySelector("p") as HTMLParagraphElement;

      if (h2) {
        h2.style.transform = "translateX(95%)";
        h2.style.opacity = "0";
      }
      if (p) {
        p.style.opacity = "0";
        p.style.transform = "translateX(95%)";
      }

      setTimeout(() => {
        // logic for h2
        h2.style.opacity = "1";
        h2.style.transform = "translateX(0%)";
      }, 250);
      setTimeout(() => {
        // logic for p
        p.style.opacity = "1";
        p.style.transform = "translateX(0%)";
      }, 500);

      const answerListComponents = Array.from(answerList.children).filter(
        (child) => child.tagName === "DIV"
      ) as HTMLDivElement[];
      if (!this.firstQuestion) {
        answerList.style.transition = "0s";
      }

      answerListComponents.forEach((component) => {
        component.style.transform = "translate(100%)";
        component.style.opacity = "0";
      });

      setTimeout(() => {
        answerListComponents.forEach((component, index) => {
          setTimeout(() => {
            component.style.transform = "translate(0%)";
            component.style.opacity = "1";
          }, 75 * index);
        });
        this.isCanScrollAnswerList = this.isScrollAnswer;
        window.addEventListener("scroll", this.isCanScrollAnswerListHandler);
      }, 750);
    },
    isCanScrollAnswerListHandler() {
      this.isCanScrollAnswerList = false;
    },
    startCalculation(event: Event | null = null, animated = false): void {
      if (this.questions.length == 0) {
        this.setQuestions();
        return;
      }
      setTimeout(() => {
        let answerList = this.$refs.answerList as HTMLElement[];
        if (answerList && Array.isArray(answerList)) {
          this.contactTranslate = answerList[0]?.clientHeight;
        }
      }, 500);
      if (event && !animated) {
        let target = event.target as HTMLButtonElement;
        if (target.type !== "submit" && target.parentElement) {
          target = target.parentElement as HTMLButtonElement;
        }
        target.classList.add(this.style.animated);
        setTimeout(() => {
          target.classList.remove(this.style.animated);
          this.startCalculation(event, true);
        }, 400);
        return;
      }
      window.scroll({top: 0, left: 0, behavior: "smooth"});
      if (this.mobileVersion && !this.onlyFormBool) {
        setTimeout(() => {
          this.sectionRightPart.forEach((HTMLElement) => {
            HTMLElement.style.display = "none";
          });
        }, 1000);
      } else {
        if (!this.onlyFormBoolInPage) {
          document.body.style.overflowY = "hidden";
        }
      }
      if (this.onlyFormBoolInPage) {
        this.nextOrCalculation();
        return;
      }
      let last = document.querySelector(
        "." + this.style.leftPart + " div#animation"
      ) as HTMLElement;
      let current = document.querySelector(
        "." + this.style.questionList
      ) as HTMLElement;
      this.animationSwitchingPage(
        last,
        current,
        () => {
          if (this.mobileVersion) {
            if (!this.onlyFormBool) {
              this.animationFirstQuestion();
              setTimeout(() => {
                this.$quizStore.setStartPage(false);
              }, 1000);
            } else {
              this.$quizStore.setStartPage(false);
            }
          } else {
            this.$quizStore.setStartPage(false);
          }
        },
        "next"
      );
    },
    async nextOrCalculation() {
      if (!this.checkingForErrors()) {
        return;
      }

      let leftPart = this.$refs.leftPart;
      if (leftPart && !Array.isArray(leftPart)) {
        leftPart.scroll({top: -100});
      }

      if (
        this.questionsListCont < this.questions.length - 1 &&
        !this.onlyFormBoolInPage
      ) {
        let questionList = Array.from(
          document.querySelectorAll("." + this.style.questionList)
        );
        let last = questionList[this.questionsListCont] as HTMLElement;
        let current = questionList[this.questionsListCont + 1] as HTMLElement;
        if (this.questionsListCont == this.getIndexContactsQuestion) {
          this.questionsListCont++;
        } else {
          this.animationSwitchingPage(
            last,
            current,
            () => {
              this.questionsListCont++;
              if (this.mobileVersion && !this.onlyFormBool) {
                setTimeout(() => {
                  this.calcPaddingAnswerList();
                }, 300);
              }
            },
            "next"
          );
        }
        return;
      }

      let inputPhone = this.getCurrentContactsPhoneInput();
      this.syncContactPhone(inputPhone);

      if (
        !this.isTelegramConnection() &&
        !this.isContactsPhoneComplete(inputPhone)
      ) {
        if (inputPhone) {
          this.inputError(inputPhone);
        }
        return;
      }

      let deviceType = "не определено";
      switch (device.type) {
        case "desktop":
          deviceType = "Компьютер";
          break;
        case "mobile":
          deviceType = "Телефон";
          break;
        case "tablet":
          deviceType = "Планшет";
          break;
      }

      if (!this.isPhoneMaskDisabled() && !this.isTelegramConnection()) {
        this.answer["Телефон"] = `+7 ${this.answer["Телефон"]}`;
      }
      let obj: {
        userId: string;
        quizId: string;
        sessionId: string;
        URL: string;
        deviceType: string;
        data: answer;
        phoneMask: boolean;
        nowReturn: string;
        Utm: string;
        envyboxStatus?:
          "sent" | "conversation" | "no_conversation" | "ok" | "error" | null;
      } = {
        userId: this.quiz.userId,
        quizId: this.quiz._id,
        sessionId: this.analyticsSessionId,
        URL: window.location.href,
        deviceType,
        data: this.answer,
        phoneMask: this.isPhoneMaskDisabled(),
        nowReturn: this.quiz.nowReturn,
        Utm: ""
      };

      const search = location.search.substring(1);
      const ym_uid = getYMCID();
      if (search != "" || ym_uid) {
        let newParams = "";
        if (search != "") {
          const params = JSON.parse(
            '{"' +
              decodeURI(search)
                .replace(/"/g, '\\"')
                .replace(/&/g, '","')
                .replace(/=/g, '":"') +
              '"}'
          );

          Object.entries(params).forEach((param) => {
            if (param[0].substring(0, 3).toLowerCase() == "utm") {
              newParams += param[0] + ": " + param[1] + "\n";
            }
          });
        }
        if (ym_uid) {
          newParams += ym_uid.replace("=", ": ") + "\n";
        }
        obj["Utm"] = newParams;
      }
      if (!obj.data) {
        return;
      }
      Object.entries(obj.data).forEach((d) => {
        if (Array.isArray(d[1]) && obj.data) {
          obj.data[d[0]] = d[1]?.join(", ");
        }
      });
      if (!this.isFormSend) {
        this.isFormSend = true;

        setTimeout(() => {
          this.isFormSend = false;
        }, 5000);
        const callComponent = this.$refs
          .callComponent as unknown as InstanceType<typeof CallComponent>;

        if (String(this.quiz.envyboxWidgetId || "").trim()) {
          obj.envyboxStatus = await this.getEnvyboxStatus(callComponent);
        }
        try {
          const payload = await encryptQuizSendPayload(obj);
          await API.sendQuiz({body: payload});

          document.body.style.overflowY = "hidden";
          this.thankyouPage = true;
          this.$quizStore.setStartPage(false);

          this.metricIds?.forEach((element) => {
            ym(Number(element.id), "reachGoal", "ReaddsQuiz");
          });
        } catch {
          this.isErrorSendForm = true;
          this.isFormSend = false;

          setTimeout(() => {
            this.isErrorSendForm = false;
          }, 2000);
        }
      }
    },
    async getEnvyboxStatus(
      callComponent: InstanceType<typeof CallComponent> | undefined
    ): Promise<"sent" | "error"> {
      const timeout = new Promise<boolean>((resolve) => {
        setTimeout(() => resolve(false), 2500);
      });

      try {
        const isSent = await Promise.race([
          callComponent?.submitFakeForm?.() ?? Promise.resolve(false),
          timeout
        ]);
        return isSent ? "sent" : "error";
      } catch (error) {
        console.warn(
          "Ошибка отправки Envybox, заявка Readds продолжит отправку:",
          error
        );
        return "error";
      }
    },
    handleClick(
      event: Event | null = null,
      movement: string,
      animatedEnd = false
    ) {
      if (this.clickTimeout) {
        clearTimeout(this.clickTimeout);
      }
      this.clickTimeout = setTimeout(() => {
        if (!animatedEnd && event && movement != "back") {
          const target = event?.target as HTMLElement;
          let parent = target.parentElement as HTMLButtonElement;
          if (parent.type !== "submit") {
            parent = parent.querySelector("button") as HTMLButtonElement;
          }
          parent.classList.add(`${this.style.animated}`);
          setTimeout(() => {
            parent.classList.remove(`${this.style.animated}`);
          }, 400);
          setTimeout(() => this.handleClick(event, movement, true), 500);
          return;
        }
        this.handleSingleClick(movement);
      }, 1);
    },
    getClassDental(index: number, name: string) {
      let data = name == "maxilla" ? this.maxilla : this.mandible;
      if (data[index].class.indexOf("dental") > -1) {
        let classDental = this.style.dental;
        if (this.chooseToothList[index]) {
          classDental += " " + style.active;
        }
        return classDental;
      }
      return this.style[data[index].class];
    },
    getDentalImg(i: number, name: string) {
      let data = name == "maxilla" ? this.maxilla : this.mandible;
      const {imgActive, imgHover, img} = data[i];
      if (this.chooseToothList[name].includes(i)) {
        return imgActive;
      }
      if (this.hoverToothList[name] == i) {
        return imgHover;
      }
      return img;
    },
    getQuestion(question: questions) {
      if (question.type == "contacts") {
        return "Контакты";
      }
      return question.question;
    },
    normalizeStringList(value: unknown): string[] {
      if (typeof value === "string") {
        return [value];
      }

      if (Array.isArray(value)) {
        return value;
      }

      return [];
    },
    getWidthAnswer(n: number) {
      if (this.quiz.questions[n].vertical && !this.mobileVersion) {
        return "calc(50% - 5px)";
      }
      return "100%";
    },
    getClassLeftPart() {
      let classLeftPart = this.style.leftPart;
      if (this.estimate) classLeftPart += " " + this.style.contacts;
      if (!this.startPage) classLeftPart += " " + this.style.question;
      else classLeftPart += " " + this.style.startPage;
      return classLeftPart;
    },
    getProcessQuestions() {
      let allQuestions = this.getIndexContactsQuestion;
      let oneProcent = allQuestions / 100;
      return Math.ceil(this.questionsListCont / oneProcent);
    },
    getStyleLogo() {
      if (!this?.quiz) return {display: "none"};
      return {transform: `scale(${this.quiz.rangeSize / 100})`};
    },
    setContacts(input: HTMLInputElement) {
      if (!this.answer) {
        return;
      }

      let name = input?.name?.split("-")[1];
      interface rusKey {
        [key: string]: string;
        name: string;
        email: string;
        phone: string;
      }
      let rusKey: rusKey = {
        name: "Имя",
        email: "Email",
        phone: "Телефон"
      };

      if (this.answer[rusKey[name]] == undefined) {
        this.answer[rusKey[name]] = "";
      }
      this.answer[rusKey[name]] = input.value;
      const question = input
        ?.closest("." + this.style.questionList)
        ?.querySelector("." + this.style.question + " h2")?.textContent;
      if (question && this.answer[question]) {
        delete this.answer[question];
      }
    },
    answerInput(e: Event, animatedEnd = false) {
      const input = e?.target as HTMLInputElement;
      if (
        input.getAttribute("name") == "contacts-phone" &&
        !this.isTelegramConnection()
      ) {
        input.value = input.value.replace(/[а-яА-ЯЁёa-zA-Z]/, "");
      }

      if ((input.type == "radio" || input.type == "checkbox") && !animatedEnd) {
        const label = input.nextElementSibling as HTMLLabelElement;
        label.classList.add(`${this.style.animatedCheckBoxRadios}`);
        setTimeout(() => {
          const label = input.nextElementSibling as HTMLLabelElement;
          label.classList.remove(`${this.style.animatedCheckBoxRadios}`);
        }, 400);
        if (input.type == "radio") {
          setTimeout(() => this.answerInput(e, true), 500);
          return;
        }
      }

      if (!this.onlyFormBool) {
        const answerListElements = this.$refs.answerList as HTMLDivElement[];
        const currentAnswerList = answerListElements[
          this.questionsListCont
        ] as HTMLDivElement;
        const selector = currentAnswerList.parentElement as HTMLDivElement;

        const question = selector?.querySelector(
          "." + this.style.question + " h2"
        )?.textContent;
        if (!this.answer) {
          return;
        }

        if (this.answer && question) {
          this.answer[question] = {};
        }
        if (input?.name == "dental") {
          if (input.id != this.dentalVariants[2]) {
            let name =
              input.id.indexOf("верхняя") != -1 ? "maxilla" : "mandible";
            this.selectionEntireJaw(input.checked, name);
          }
          if (question) {
            delete this.answer[question];
          }
        }
        if (selector == null) {
          return;
        }
        const answerList = selector.querySelector("." + this.style.answerList);
        if (!answerList) {
          return;
        }
        let answerAll = Array.from(
          answerList.querySelectorAll("div")
        ) as HTMLDivElement[];
        answerAll = answerAll ? answerAll : [];

        answerAll.forEach((answer) => {
          const inputList = answer.querySelectorAll("input");
          inputList.forEach((input) => {
            if (
              this.answer &&
              question &&
              input.type == "radio" &&
              input.checked == true
            ) {
              let label = document.querySelector(`label[for="${input.id}"]`);
              this.answer[question] = label?.textContent;
            }

            if (
              this.answer &&
              question &&
              input.type == "checkbox" &&
              input.checked &&
              input.name.indexOf("dental") == -1
            ) {
              if (!Array.isArray(this.answer[question])) {
                this.answer[question] = [];
              }
              let label = document.querySelector(`label[for="${input.id}"]`);
              this.answer[question].push(label?.textContent);
            }

            if (input.name.indexOf("contacts") != -1) {
              this.setContacts(input);
            }
          });
        });
      }

      if (this.onlyFormBool) {
        this.setContacts(input);
      }

      if (input.type == "radio" && input.checked == true) {
        this.handleClick(null, "next");
      }
    },
    getLogoHeight() {
      setTimeout(() => {
        if (!this.mobileVersion) {
          const logoBlock = document.querySelector(
            "." + this.style.logo
          ) as HTMLDivElement;
          const logo = logoBlock.querySelector("img") as HTMLElement;
          this.heightLogo = logo.offsetHeight;
        }
      }, 100);
    },
    calcPaddingAnswerList() {
      this.currentAnswerPadding = this.getPaddingAnswerList;
    },
    animationFirstQuestion() {
      const leftPart = this.$refs.leftPart as HTMLDivElement;
      setTimeout(() => {
        leftPart.style.transition = ".5s";
        leftPart.style.bottom = "";
        leftPart.style.height = "100%";
      }, 500);

      const mainBlockLeftPart = leftPart.querySelector(
        "." + this.style.mainBlockLeftPart
      ) as HTMLDivElement;
      mainBlockLeftPart.style.opacity = "0";

      const questionMainBlock = document.querySelector(
        "." + this.style.questionMainBlock
      ) as HTMLDivElement;

      const buttons = document.querySelector(
        "." + this.style.buttons
      ) as HTMLDivElement;
      buttons.style.opacity = "0";
      setTimeout(() => {
        setTimeout(() => {
          buttons.style.opacity = "1";
        }, 700);
        this.answerListAnimation(questionMainBlock);
      }, 1000);
    }
  },
  computed: {
    quiz(): Quiz {
      return this.$quizStore.getQuiz;
    },
    mobileVersion(): boolean {
      return this.$quizStore.getMobileVersion;
    },
    getLogoQuiz() {
      const logo = this.modifyQuiz("get", "", ["logo"]);
      if (!logo) return "https://readds.ru/img?name=readds.svg";
      return "https://readds.ru/img?name=" + logo;
    },
    chooseToothListString() {
      return JSON.stringify(this.chooseToothList);
    },
    isLastQuestionAndNotError() {
      return this.isLastQuestion && !this.isErrorSendForm;
    },
    isSuccessAndNotSend() {
      return !this.isFormSend && !this.isErrorSendForm;
    },
    answerString() {
      return JSON.stringify(this.answer);
    },
    isLastQuestion() {
      return this.questionsListCont === this.questions.length - 1;
    },
    isCurrentContactQuestion() {
      return Boolean(
        this.questions[this.questionsListCont]?.some(
          (question) => question?.type === "contacts"
        )
      );
    },
    getIndexContactsQuestion() {
      let searchIndex = 0;
      this.quiz.questions.find((question, index) => {
        if (question.type == "contacts") {
          searchIndex = index;
        }
      });
      return searchIndex;
    },
    getAnswerListHeight() {
      let refsAnswerList = this.$refs.answerList;
      if (!refsAnswerList) {
        return 0;
      }
      if (Array.isArray(refsAnswerList)) {
        return refsAnswerList[0].offsetHeight;
      }
      return refsAnswerList.offsetHeight;
    },
    onlyFormBool() {
      return this.modifyQuiz("get", "", ["onlyFormBool"]);
    },
    onlyFormBoolInPage() {
      return (
        this.modifyQuiz("get", "", ["onlyFormBool"]) && !this.mobileVersion
      );
    },
    startPage() {
      return this.$quizStore.getStartPage;
    },
    getConnectionContacts() {
      return this.quiz.questions[this.getIndexContactsQuestion].connection;
    },
    getPaddingAnswerList(): number {
      const buttons = document.querySelector(
        "." + this.style.buttons
      ) as HTMLDivElement;
      if (buttons?.offsetHeight) {
        return buttons.offsetHeight + 30;
      }

      return 0;
    },
    firstQuestion() {
      return this.questionsListCont === 0;
    },
    getCurrentAnswerList() {
      const answerListDOM = this.$refs.answerList as HTMLDivElement[];
      const currentAnswerList = answerListDOM[this.questionsListCont];
      return currentAnswerList;
    },
    getHeightCurrentQuestion() {
      const questionBlock = this.getCurrentAnswerList
        .previousElementSibling as HTMLDivElement;
      return questionBlock.offsetHeight;
    },
    getButtonsElementHeight() {
      const buttons = document.querySelector(
        "." + this.style.buttons
      ) as HTMLDivElement;
      return buttons.offsetHeight;
    },
    isScrollAnswer() {
      return (
        this.maxHeightDisplay -
          this.getHeightCurrentQuestion -
          this.getButtonsElementHeight <
        this.getCurrentAnswerList.offsetHeight
      );
    },
    phones(): string[] {
      return this.normalizeStringList(this.modifyQuiz("get", "", ["phone"]));
    },
    addresses(): string[] {
      return this.normalizeStringList(this.modifyQuiz("get", "", ["address"]));
    },
    contactMode(): ContactsDisplayType {
      return this.modifyQuiz("get", "", ["styleContacts", "type"]) || "both";
    },
    visiblePhones(): string[] {
      if (this.contactMode !== "onlyPhone" && this.contactMode !== "both") {
        return [];
      }

      return this.phones;
    },
    visibleAddresses(): string[] {
      if (this.contactMode !== "onlyAddress" && this.contactMode !== "both") {
        return [];
      }

      return this.addresses;
    },
    nextButton(): string {
      return this.modifyQuiz("get", "", ["nextButton"]) || "Рассчитать";
    },
    textContactButton(): string {
      return this.modifyQuiz("get", "", ["textContactButton"]) || "Рассчитать";
    }
  },
  watch: {
    startPage(data) {
      document.documentElement.style.overflow = data ? "" : "hidden";
      if (!data) {
        this.setAnaliticsQuestions();
      }

      this.$nextTick(() => {
        if (this.mobileVersion && !this.onlyFormBool) {
          this.calcPaddingAnswerList();
        }
      });
    },
    thankyouPage(data) {
      if (data) {
        this.setAnaliticsQuestions();
        //
      }
    },
    chooseToothListString() {
      let dentaQ = this.quiz.questions.find((q) => {
        return q.type == "checkbox-dental";
      });
      if (!dentaQ) {
        return;
      }
      const {maxilla, mandible} = this.chooseToothList;
      const dentalInputs = Array.from(
        document.querySelectorAll("input[name=dental]")
      ) as HTMLInputElement[];
      const maxillaInput = dentalInputs[0];
      const mandibleInput = dentalInputs[1];
      maxillaInput.checked = maxilla.length == 16;
      mandibleInput.checked = mandible.length == 16;
      if (!this.answer) {
        return;
      }
      if (maxilla.length != 0) {
        this.answer["Верхняя челюсть"] =
          maxilla.length == 16 ? "Вся" : maxilla.join(", ");
      } else {
        this.answer["Верхняя челюсть"] = "";
      }
      if (mandible.length != 0) {
        this.answer["Нижняя челюсть"] =
          mandible.length == 16 ? "Вся" : mandible.join(", ");
      } else {
        this.answer["Нижняя челюсть"] = "";
      }
    },
    answerString() {
      let dentaQ = this.quiz?.questions?.find((q) => {
        return q.type == "checkbox-dental";
      });
      if (!dentaQ) {
        return;
      }
      this.answerError.clear();
      const input = document.querySelectorAll(
        "input[name=dental]"
      )[2] as HTMLInputElement;
      const text = ", нужна консультация";
      const jaws = ["Верхняя челюсть", "Нижняя челюсть"];
      jaws.forEach((jaw) => {
        if (this.answer[jaw] || this.answer[jaw] == "") {
          if (input?.checked) {
            this.answer[jaw] += this.answer[jaw].includes(text.substring(2))
              ? ""
              : text;
          } else {
            this.answer[jaw] = this.answer[jaw]?.replace(text, "");
          }
          if (this.answer[jaw].substring(0, 2) == ", ") {
            this.answer[jaw] = text.substring(2);
          }
        } else {
          this.answer[jaw] = text.substring(2);
        }
      });
    },
    questionsListCont(data) {
      this.estimate = this.quiz?.questions[data].type == "contacts";
      if (this.mobileVersion) {
        document.body.style.overflow = this.startPage ? "" : "hidden";
      } else {
        if (!(document.body.style.overflowY === "hidden")) {
          document.body.style.overflow = this.estimate ? "hidden" : "";
        }
      }

      if (this.estimate) {
        this.metricIds.forEach((element) => {
          ym(Number(element.id), "reachGoal", "ReaddsQuizСontacts");
        });
      }
      // setTimeout(this.autoFocusFirstInput, this.estimate ? 300 : 0)
      // this.$emit("prepairedPrintPhoto");
    },
    metricIds(data: metricIntegration[]) {
      addMetrik(data.map((m) => m.id));
    }
  }
});
</script>

<style scoped>
.fade-arrow-enter-active,
.fade-arrow-leave-active {
  transition:
    opacity 0.5s ease,
    transform 0.4s ease;
}

.fade-arrow-enter-from,
.fade-arrow-leave-to {
  opacity: 0;
  transform: translateY(10px);
}
</style>
